import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import { PosCard } from 'pos-client/components/shared/Display/Card/PosCard.tsx';
import { PosPageContent } from 'pos-client/layouts/page/PosPageContent.tsx';
import { NewHoursGroupModal } from 'pos-client/pages/locations/Modals/NewHoursGroupModal.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

import { HoursGroups } from './HoursGroups/HoursGroups.tsx';

export const OpeningHoursPage = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { getAllOpeningHoursGroups } = trpc.useContext();
  const { t } = useTranslation();
  const handleOk = async () => {
    await getAllOpeningHoursGroups.invalidate();
    setIsModalOpen(false);
  };
  const handleCancel = () => setIsModalOpen(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  return (
    <PosPageContent>
      <PosCard
        headerProps={{
          title: t('locations.trading.openingHours'),
          icon: faClock,
          description: t('locations.trading.pageDescription'),
          action: (
            <Button
              onClick={showModal}
              type="primary"
              icon={<FontAwesomeIcon icon={faPlus} />}
            >
              {t('locations.trading.createHoursGroup')}
            </Button>
          ),
        }}
      >
        <NewHoursGroupModal
          isVisible={isModalOpen}
          handleCancel={handleCancel}
          handleOk={handleOk}
        />

        <HoursGroups />
      </PosCard>
    </PosPageContent>
  );
};
